import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';
import { MessageService } from '@src/app/_services/message.service';
import { registerLocaleData } from '@angular/common';
import { Holiday } from '@src/app/_models/holiday/holiday';

import moment from 'moment';
import localeCs from '@angular/common/locales/cs';
import { EnvironmentService } from '@src/app/_services/environment.service';
import { UntilDestroy } from '@ngneat/until-destroy';

moment.updateLocale('cs', { workingWeekdays: [1, 2, 3, 4, 5] });
registerLocaleData(localeCs);

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class HolidayService {
    private readonly holidaysUrl: string;

    currHolidays: Observable<Holiday[] | undefined>;

    constructor(
        private readonly http: HttpClient,
        private readonly messageService: MessageService,
        private readonly environmentService: EnvironmentService
    ) {
        this.holidaysUrl = this.environmentService.backendURL + '/api/hotline/holidays/cz/';
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: { [key: string]: string }): Observable<T | undefined> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result);
        };
    }

    /** Log a vacationService message with the MessageService */
    private log(message: string): void {
        this.messageService.addNotification(`Vacation: ${message}`, false);
    }

    getCurrCZEHolidays(date?: string): Observable<Holiday[] | undefined> {
        const url = date ? `${this.holidaysUrl}/${date}` : `${this.holidaysUrl}`;

        this.currHolidays = this.http.get<Holiday[]>(url).pipe(
            tap(() => {
                this.log('fetched holidays');
            }),
            shareReplay(),
            catchError(this.handleError<Holiday[]>('getCurrHoliday'))
        );

        return this.currHolidays;
    }
}
